import ProductPreview from "./ProductPreview";

const screens = [
  {
    name: "overview",
    title: "A bureau-wide view",
    description: "Client companies, employee totals and recent payroll activity in one overview. The sample RTI items are overdue and untransmitted; the warnings remain visible.",
    alt: "Synthetic Payroll bureau dashboard showing 5 client companies, 11 active employees, recent committed sample runs and 5 overdue RTI items. No future pay date is scheduled.",
    width: 2240, height: 1180,
    screenLabel: "KedByte Payroll / Bureau dashboard",
    linkLabel: "View dashboard at full resolution",
    viewerTitle: "Dashboard preview",
    viewerNote: "Overdue RTI items are untransmitted.",
    note: "Selected dashboard area; additional activity rows are outside this crop. Sample RTI warnings are preserved.",
  },
  {
    name: "detail",
    title: "The detail behind a payslip",
    description: "A read-only review of a committed sample payroll: payments, PAYE, National Insurance, pension and student-loan deductions, alongside net pay. The displayed approval label is a seeded application status, not an HMRC acknowledgement.",
    alt: "Synthetic employee payslip review with £3,200 gross pay, itemised deductions of £357.36 and £2,842.64 net pay. The sample record carries an application-level Approved label.",
    width: 2224, height: 888,
    screenLabel: "KedByte Payroll / Payslip review",
    linkLabel: "View payslip review at full resolution",
    viewerTitle: "Payslip preview",
    viewerNote: "Approved is an application status, not an HMRC acknowledgement.",
  },
];

export default function PayrollPreview() {
  return <ProductPreview product="payroll" root="/images/payroll-preview-20260922"
    heading="From bureau overview to a single payslip."
    introduction="Actual interface captures from a modified, synthetic-data capture environment. Background jobs and external submissions were disabled. These images are not evidence of production readiness, background-job correctness or HMRC approval."
    screens={screens} />;
}
